<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
    <z-page title="Butiran : Bil Pelbagai" >

    <w-card bg-color="" class="">
        <w-flex justify-center align-center>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      No. Bil :
                  </h5>
                  <div class="fw-normal my1 fs-1"> INV202109887 </div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Tarikh Bil :
                  </h5>
                  <div class="fw-normal my1 fs-1">
                    <template v-if="id == '2'">
                        25-01-2022
                    </template>
                    <template v-else>
                        26-01-2022
                    </template>
                  </div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Tarikh Bil :
                  </h5>
                  <div class="fw-normal my1 fs-1">
                    <template v-if="id == '2'">
                        25-04-2022
                    </template>
                    <template v-else>
                        26-05-2022
                    </template>
                  </div>
            </div>
        </w-flex>
        <w-flex justify-center align-center>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Profil :
                  </h5>
                  <div class="fw-normal my1 fs-1"> ALI MAJU SDN. BHD.</div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Alamat :
                  </h5>
                  <div class="fw-normal my1 fs-1"> LOT 213, BLOK B, MEDAN SELERA JITRA</div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Status :
                  </h5>
                  <div class="fw-normal my1 fs-1">
                    <template v-if="id == '2'">
                        BAYAR
                    </template>
                    <template v-else>
                        BAHARU
                    </template>
                  </div>
            </div>
        </w-flex>
    </w-card>

    <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess">    
        <w-flex justify-center align-center class="table-hardcode">
        
            <div class="w-card__content content-hardcode mt3">
                <table class="table-dashboard" width="100%" >
                    <thead>
                        <tr>
                            <td>Bil</td>
                            <td>Kod CAA</td>
                            <td>Butiran</td>
                            <td>Kuantiti</td>
                            <td>Kadar (RM)</td>
                            <td>Amaun (RM)</td>
                            <td> <w-icon  @click="dialog.show2 = true">fal fa-plus</w-icon></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>H0174108 | SEWA KIOSK</td>
                            <td>SEWA KIOSK</td>
                            <td>3</td>
                            <td align="right">189.30</td>
                            <td align="right">567.90</td>
                            <td align="center">
                                <w-icon dark tile >fal fa-pencil</w-icon>
                                &nbsp;
                                <w-icon dark tile >fal fa-trash</w-icon>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5" align="right">JUMLAH</td>
                            <td align="right">567.90</td>
                            <td align="center"></td>
                        </tr>
                        <tr>
                            <td colspan="5" align="right">PENGGENAPAN</td>
                            <td align="right">570.00</td>
                            <td align="center"></td>
                        </tr>
                        <tr>
                            <td colspan="5" align="right">JUMLAH PERLU DIBAYAR</td>
                            <td align="right">570.00</td>
                            <td align="center"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </w-flex>
         <w-dialog
          v-model="dialog.show2"
          :fullscreen="dialog.fullscreen"
          :width="dialog.width"
          :persistent="dialog.persistent"
          :persistent-no-animation="dialog.persistentNoAnimation"
          title-class="primary-light1--bg white">
                  <template #title>
                    <w-icon class="mr2">mdi mdi-tune</w-icon>
                    Tambah Butiran Bil
                  </template>
                  <w-flex justify-space-between class="mb4">
                        <w-select label="Kod CAA" v-model="form.kod_caa" :items="[{label: 'H0174108 | SEWA KIOSK'}]" />
                    </w-flex>
                    <w-flex justify-space-between class="mb4">
                        <z-input label="Butiran" v-model="form.butiran" name="Butiran" :validators="[validators.required]" />
                    </w-flex>
                    <w-flex justify-space-between class="mb4">
                        <z-input label="Kuantiti" v-model="form.kuantiti" name="Kuantiti" :validators="[validators.required]" />
                    </w-flex>
                    <w-flex justify-space-between class="mb4">
                        <z-input label="Kadar (RM)" v-model="form.kadar" name="Kadar (RM)" :validators="[validators.required]" />
                    </w-flex>
                    <w-flex justify-space-between class="mb4">
                      <div class="xs4">
                              Amaun (RM) :
                          <div class="fw-normal my1 fs-1"> 0.00 </div>
                      </div>
                </w-flex>
                <template #actions>
              <div class="spacer" />
                <w-button bg-color="grey-light5--bg" @click="dialog.show2 = false">Tutup</w-button>
                <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">Simpan
                </w-button>
            </template>
         </w-dialog>

         <w-flex class="mt4" wrap align-center justify-end>
                <w-button bg-color="error-dark1" dark tile @click="destroy(item)">
                     <w-icon dark tile >fal fa-trash</w-icon>
                </w-button>
                 &nbsp;
                 <w-button bg-color="success" class="mr3" @click="cetak()">
                    <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                </w-button>
                 <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                    <w-icon dark tile >fal fa-save</w-icon>
                </w-button>
        </w-flex>

    </w-form>

    
  
        

        
      
        
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'

export default {
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

    dialog: {
        show2: false,
        fullscreen: false,
        persistent: false,
        persistentNoAnimation: false,
        width: 500
  },
  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0,
    jenis:'',
    no:'',
  },
  validators: {
    required: value => !!value || 'This field is required',
    consent: value => !!value || 'You must agree'
  },
      resourceurl: 'deposit',
      reload: true,
      data: {
        permissions: [],
        roles: [],
      },
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Bayaran', route: '/bayaran' },
        { label: 'Show', route: '/bayaran/1' },
      ],
    }
  },
  methods: {
    onSuccess () {
    setTimeout(() => (this.form.sent = true), 2000)
    this.$inertia.visit(window.route('bilpelbagai.index'));

  },
  cetak() {
            window.location.href = route('bilpelbagai.cetak');
        },
  
  },
  watch: {

  },
  mounted() {
    
      
  },
}
</script>